<template>
  <div>
    <h3>URLs</h3>
    <Loading v-if="!loaded"></Loading>
    <div v-else>
      <v-list v-if="urls.length >= 1">
        <FunctionUrl
          v-for="url in urls"
          :key="url.id"
          :id="parseInt(url.id)"
          :url="url.url"
          :method="url.method"
          :secret="url.secret"
          :service="url.service"
          :additional_params="url.additional_params"
          @urlsChanged="loadUrls"
        ></FunctionUrl>
      </v-list>
      <div v-else style="text-align: center">
        <p>No URLs registered.</p>
      </div>
    </div>
    <hr style="margin-bottom:10px;">
    <form @submit="addUrl">
      <v-layout row style="margin: 0">
        <v-flex>
          <v-text-field
            v-model="new_url"
            type="url"
            label="URL"
            placeholder="https://"
            style="margin: 0"
          ></v-text-field>
          <v-select
            label="Method"
            v-model="new_method"
            no-data-text="No methods available"
            style="margin: 0"
            :items="methods"
          ></v-select>
        </v-flex>
        <v-flex xs2 style="padding-top: 20px">
          <v-btn type="submit" text><i class="fal fa-save"></i></v-btn>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
import FunctionUrl from "./FunctionUrl";
import { Functions } from "../../logic/Functions";
import { Notifications } from "../../notification";

export default {
  props: {
    function_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      urls: [],
      methods: [
        {
          text: "GET",
          value: "get",
        },
        {
          text: "POST",
          value: "post",
        },
        {
          text: "PUT",
          value: "put",
        },
        {
          text: "DELETE",
          value: "delete",
        },
        {
          text: "PATCH",
          value: "patch",
        },
        {
          text: "OPTIONS",
          value: "options",
        },
      ],

      new_method: "post",
      new_url: "",

      loaded: false,
    };
  },
  mounted() {
    this.loadUrls();
  },
  methods: {
    async loadUrls() {
      var response = await Functions.loadUrls(this.function_id);
      this.loaded = true;
      if (response.status === 200) {
        this.urls = response.body;
      } else {
        this.urls = [];
      }
    },
    async addUrl(e) {
      e.preventDefault();
      var response = await Functions.addUrl(
        this.function_id,
        this.new_method,
        this.new_url,
        this.makeid(30)
      );
      if (response.status === 200) {
        this.loadUrls();
        this.new_method = "post";
        this.new_url = "";
        Notifications.show("The URL has been registered to this function.");
      } else {
        Notifications.show(response.message);
      }
    },

    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
  components: {
    FunctionUrl,
  },
};
</script>

<style>
</style>